@if (!!customerPriceMarkup) {
<div class="modal-header">
  <h5 class="modal-title m-0" id="modal-basic-title">{{ 'EDIT_CUSTOMER_B2C_MARKUP' | translate: { customerId: customerPriceMarkup.customerId } }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
}

<div class="modal-body">
  @if (!!customerPriceMarkup) {
    <lib-gung-number-input
      [(ngModel)]="customerPriceMarkup.markupPercentage"
      gungTranslate="{{ 'EDIT_CUSTOMER_B2C_MARKUP' | translate: { customerId: customerPriceMarkup.customerId } }}"
      placeholder="0"
    ></lib-gung-number-input>
  } @else {
    <div class="d-flex justify-content-center align-items-center">
      <i class="fas fa-spinner fa-spin fa-5x"></i>
    </div>
  }
</div>

@if (!!customerPriceMarkup) {
<div class="modal-footer">
  <gung-button
    [label]="'SAVE'"
    classes="btn-primary text-white"
    [onClick]="save.bind(this)"
  />
  <gung-button
    [label]="'CLOSE'"
    classes="btn-secondary text-white"
    [onClick]="close.bind(this)"
  />
</div>
}
